export default __webpack_public_path__ + "images/a16a019e488a09d8252d3fbb5e889f8d.svg";